import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CompanyBranding } from '../types';

@Injectable({
  providedIn: 'root',
})
export class WhiteLabelService {
  public whiteLabel: Observable<CompanyBranding>;
  private whiteLabelSubject: BehaviorSubject<CompanyBranding>;

  constructor() {
    this.whiteLabelSubject = new BehaviorSubject(new WhiteLabel());
    this.whiteLabel = this.whiteLabelSubject.asObservable();
  }

  public getState(): CompanyBranding {
    return this.whiteLabelSubject.getValue();
  }

  public setState(whiteLabel: CompanyBranding): void {
    this.whiteLabelSubject.next(whiteLabel);
  }
}

class WhiteLabel implements CompanyBranding {
  public clientUrl = '';
  public companyName = '';
  public logoUrl = '';
}
